const SEGMENTOS_LABELS = {
  associacao: "Associação",
  clinica: "Clínica",
  farmaceutica: "Farmacêutica",
  homecare: "Home care",
  hospital: "Hospital",
  laboratorio: "Laboratório",
  operadora: "Operadora",
  outros: "Outros",
};

const PROCURA_LABELS = {
  consultoria: "Consultoria",
  contrucao_civil: "Construção civil",
  consumiveis: "Consumíveis",
  equipamentos: "Equipamentos",
  facilities: "Facilities",
  homecare: "Home care",
  servicos: "Serviços",
  tecnologia: "Tecnologia",
  outros: "Outros",
};

function v(valor) {
  const t = String(valor ?? "").trim();
  return t || "—";
}

function complementoSegmento(
  tipoInstituicao,
  segmentoOutros,
  numeroLeitos,
  numeroVidas,
) {
  if (tipoInstituicao === "hospital") {
    const leitos = String(numeroLeitos ?? "").trim();
    return leitos ? { rotulo: "Número de Leitos:", valor: leitos } : null;
  }
  if (tipoInstituicao === "operadora") {
    const vidas = String(numeroVidas ?? "").trim();
    return vidas ? { rotulo: "Número de Vidas:", valor: vidas } : null;
  }
  if (tipoInstituicao === "outros") {
    const outros = String(segmentoOutros ?? "").trim();
    return outros ? { rotulo: "Outro segmento:", valor: outros } : null;
  }
  return null;
}

function labelSegmento(tipoInstituicao) {
  if (!tipoInstituicao) return "—";
  return SEGMENTOS_LABELS[tipoInstituicao] || tipoInstituicao;
}

function labelProcura(procura, outros) {
  if (!procura) return "—";
  const base = PROCURA_LABELS[procura] || procura;
  if (procura === "outros" && outros?.trim()) {
    return `${base} — ${outros.trim()}`;
  }
  return base;
}

function labelProcuraTag(procura) {
  if (!procura) return "—";
  return PROCURA_LABELS[procura] || procura;
}

/** Espelha resolveLabelsConvidado do backend (dossiê PDF). */
export function resolveLabelsConvidado(convidado) {
  if (!convidado) {
    return {
      nomeExibicao: "—",
      empresaExibicao: "Sem instituição informada",
      segmento: "—",
      complementoRotulo: null,
      complementoValor: "—",
      faturamento: "—",
      estado: "—",
      regiao: "—",
      prioridade: "—",
      transformacao: "—",
      procuraSbf: "—",
      procuraTag: "—",
      hobby: "—",
      bio: "—",
      cargo: "—",
    };
  }

  const nomeCracha = convidado.nomeCracha ?? convidado.nome_cracha;
  const tipoInstituicao =
    convidado.tipo_instituicao ?? convidado.tipoInstituicao ?? null;
  const complemento = tipoInstituicao
    ? complementoSegmento(
        tipoInstituicao,
        convidado.segmento_outros ?? convidado.segmentoOutros ?? null,
        convidado.numero_leitos ?? convidado.numeroLeitos ?? null,
        convidado.numero_vidas ?? convidado.numeroVidas ?? null,
      )
    : null;

  return {
    nomeExibicao: v(nomeCracha || convidado.nome),
    empresaExibicao:
      v(convidado.empresa) === "—"
        ? "Sem instituição informada"
        : v(convidado.empresa),
    segmento: labelSegmento(tipoInstituicao),
    complementoRotulo: complemento?.rotulo ?? null,
    complementoValor: v(complemento?.valor),
    faturamento: v(
      convidado.faturamento_instituicao ?? convidado.faturamentoInstituicao,
    ),
    estado: v(convidado.estado),
    regiao: v(convidado.regiao),
    prioridade: v(convidado.prioridade),
    transformacao: v(convidado.transformacao),
    procuraSbf: labelProcura(
      convidado.procura_sbf ?? convidado.procuraSbf ?? null,
      convidado.outros_procura_sbf ?? convidado.outrosProcuraSbf ?? null,
    ),
    procuraTag: labelProcuraTag(
      convidado.procura_sbf ?? convidado.procuraSbf ?? null,
    ),
    hobby: v(convidado.hobby),
    bio: v(convidado.bio),
    cargo: v(convidado.cargo),
  };
}
